<app-request-an-insurance-quote
 mainHeading="Thank you"
 subHeading="false"
 ></app-request-an-insurance-quote>
<!-- //  I N T R O    -->
<section id="rtq-form" class="pb-5">
    <div class="container">
       <img  src="assets/img/PRELOADER.gif" class="preloader"  *ngIf="isLoading"/>
        <div class="row justify-content-center">
            <div class="col-md-8 col-xs-12" *ngIf="!this.dataService.leadDetails.isServiceUnavailable">
                <div class="form-div z-indexHeader">
                    <div class="row pt-3 text-center">
                        <div class="col pt-2">
                            <p>
                                Thank you for choosing Westwood Insurance Agency. We will contact you shortly to
                                address any
                                questions and discuss
                                the next
                                steps. Our normal business hours are 8AM to 7PM CST, Monday through Friday. You may
                                also call us at
                                <a href="tel:{{commonService.formatPhoneNumber(leadDetails.salesAgent.phoneNumber)}}">{{leadDetails.salesAgent.phoneNumber}}</a>.
                            </p>
                        </div>
                    </div>
                    <div class="row pt-3 text-center">
                        <div class="col-lg-6 col-xs-12 col-sm-12 pt-2" *ngFor="let prod of additionalProducts; let i = index"> 
                                <a class="show-cursor" (click)="child.importantNotice($event, prod.link)" href="#" *ngIf="prod.fileURL!=''"> 
                                    <img [src]="prod.fileURL" height="54px" width="258px" class="img-responsive addProduct"/>
                                </a> 
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col" *ngIf="this.dataService.leadDetails.isServiceUnavailable">
                                <p class="font-weight-bold header-blue mb-0 pb-0 text-sm-center p-2" [innerHTML]="dataService.leadDetails.errorMessage">
                                </p>

                        </div>
                    </div>        
                </div>
            </div>
        </div>
    </div>
</section>

<!-- E X T E R N A L    S I T E    M O D A L   --> 

<app-model-pop-up-other-domain></app-model-pop-up-other-domain> 

<!-- E X T E R N A L    S I T E    M O D A L   -->